import { Component, inject } from '@angular/core';
import {
  IconManager,
  iconPanel,
  NavigationBarComponent,
  LogoComponent,
  PermissionSomeDirective,
} from '@tiltgroup/web-components';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { SideNavigationStateService } from '@services/side-navigation-state.service';
import { Permission } from '@shared/interfaces/permission';
import { GlobalSearchComponent } from '@components/global-search/global-search.component';

@Component({
  selector: 'lig-navigation',
  standalone: true,
  imports: [
    LogoComponent,
    NavigationBarComponent,
    MatButtonModule,
    MatIconModule,
    PermissionSomeDirective,
    GlobalSearchComponent,
  ],
  templateUrl: './navigation.component.html',
  styleUrls: ['./navigation.component.scss'],
})
export class NavigationComponent {
  private _iconManager = inject(IconManager);

  protected sidebarState = inject(SideNavigationStateService);

  /** The global search is shown when the user can view either entity it covers. */
  protected readonly searchPermissions = [
    Permission.VIEW_SHIPMENT,
    Permission.VIEW_LTL_QUOTE_REQUEST,
  ];

  constructor() {
    this._iconManager.addIcons([{ name: 'panel', icon: iconPanel }]);
  }
}
